import { Component, OnInit } from '@angular/core';
import {OrderDetailTotalsComponent} from "@spartacus/order/components";
import {GonvarriCartOutlets} from "../../core/models/gonvarri-cart-outlets.model";

@Component({
  selector: 'cx-order-details-totals',
  templateUrl: './gonvarri-order-detail-totals.component.html',
  standalone:false
})
export class GonvarriOrderDetailTotalsComponent  extends OrderDetailTotalsComponent {

  readonly GonvarriCartOutlets = GonvarriCartOutlets;
}
